module.exports = __webpack_public_path__ + "9933ab724ac62360a2bc7f62ba08f44b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/list/content-bg.jpg
// module id = 1137
// module chunks = 0